import React from "react";
import { colors } from "../../../../../../themes/Colors";

const HeaderThirdPartyRequest = () => {
  return (
    <div
      style={{
        height: 40,
        width: "100%",
        backgroundColor: colors.greenLight,
        marginTop: 2.5,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <div
        style={{
          flex: 0.2,
          color: colors.white,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> BUSINESS NAME</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.15,
          color: colors.white,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> SERVICE</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          color: colors.white,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> EMAIL</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.15,
          color: colors.white,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> CELL NUMBER</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.15,
          color: colors.white,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ marginLeft: 10 }}> STATUS</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          color: colors.white,
          fontWeight: "bold",
          fontSize: 12,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ marginLeft: 0 }}> ACTIONS</div>
        </div>
      </div>
    </div>
  );
};

export default HeaderThirdPartyRequest;
